import { BuildInfo } from '@/components/BuildInfo';
import { ReviewReminderSettings } from '@/components/ReviewReminder';
import { InstallApp } from '@/components/InstallApp';
import type { useInstallApp } from '@/hooks/useInstallApp';
import { useTranslation } from 'react-i18next';
import { LanguageToggle } from '@/components/LanguageToggle';
import { ThemeToggle } from '@/components/ThemeToggle';
import { SessionsPanel } from '@/components/SessionsPanel';
import { LoginHistory } from '@/components/LoginHistory';
import { Button } from '@/components/ui/button';
import { useLogout } from '@/lib/queries';

export default function SettingsPage({ install }: { install: ReturnType<typeof useInstallApp> }) {
  const { t } = useTranslation();
  const logout = useLogout();
  return (
    <section className="flex max-w-prose flex-col gap-6">
      <h1 className="font-serif text-2xl font-semibold">{t('settings.title')}</h1>

      <div className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-line bg-surface px-5 py-4">
        <span className="text-sm">{t('settings.language')}</span>
        <LanguageToggle />
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3 rounded-card border border-line bg-surface px-5 py-4">
        <span className="text-sm">{t('settings.appearance')}</span>
        <ThemeToggle />
      </div>

      <ReviewReminderSettings />
      <InstallApp state={install} />

      <SessionsPanel />

      <LoginHistory />

      <BuildInfo />
      {logout.isError && (
        <p role="alert" className="text-sm text-muted">
          {t('week.saveFailed')}
        </p>
      )}

      <div className="flex flex-wrap gap-2">
        <a
          href="/api/account/export"
          className="inline-flex min-h-11 min-w-11 items-center rounded-lg border border-line bg-surface px-4 text-sm hover:border-accent"
        >
          {t('account.export')}
        </a>
        <Button size="sm" onClick={() => logout.mutate()}>
          {t('auth.signOut')}
        </Button>
      </div>
    </section>
  );
}
